import styled from 'styled-components';

export const MyBookingMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        border-radius: 10px;
        box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
        margin-top: ${props.theme.spacing.large.l20};
        padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l40};
    `
);

export const MyBookingsHeaderWrap = styled.div(
    props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    `
);

export const MyBookingsFooterWrap = styled(MyBookingsHeaderWrap)`
  padding-top: 2rem;
`;

export const MyBookingsHeadText = styled.p(
    props => `
    font-size: 2.8rem;
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    `
);
  

export const ViewAllBookingsText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-align: right;
        cursor: pointer;
    `
);

export const MyBookingsOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        
    `
);



